// extracted by mini-css-extract-plugin
module.exports = {"glyphAndTextContainer":"GlyphAndText_glyphAndTextContainer__39fRH","glyphWrapper":"GlyphAndText_glyphWrapper__1XfIS","textWrapper":"GlyphAndText_textWrapper__1b-oP"};